import { Sync, registerSync } from 'olympe';

/**
 * @extends {Sync}
 */
export class MapboxCamera extends Sync {

}

// Hardcoded tags
MapboxCamera.entry = registerSync('017c3ca26fe82389c261', MapboxCamera);
MapboxCamera.latitudeProp = MapboxCamera.entry.addProperty('017c3ca29a418bee4e7c');
MapboxCamera.longitudeProp = MapboxCamera.entry.addProperty('017c3ca2b5fa37238be2');
MapboxCamera.altitudeProp = MapboxCamera.entry.addProperty('017c3ca2c940df9a44e8');
MapboxCamera.pitchProp = MapboxCamera.entry.addProperty('017c5641541f81f54f15');
MapboxCamera.bearingProp = MapboxCamera.entry.addProperty('017c56415ccbbdf29d16');

